var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "w-row",
    { attrs: { "no-margin": "" } },
    [
      _c(
        "w-col",
        { attrs: { "no-margin": "" } },
        [
          _c(
            "w-card",
            [
              _c("w-card-title", [_vm._v(_vm._s(_vm.$ct("freeLines")))]),
              _c(
                "w-card-content",
                [
                  _c(
                    "w-row",
                    [
                      _c(
                        "w-col",
                        [
                          _c("app-custom-language-select", {
                            model: {
                              value: _vm.lang,
                              callback: function ($$v) {
                                _vm.lang = $$v
                              },
                              expression: "lang",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "w-row",
                    { staticClass: "value-button" },
                    [
                      _c(
                        "w-col",
                        { attrs: { xs: "12" } },
                        [
                          _c("w-input", {
                            attrs: { fancy: "", label: _vm.$ct("titleLabel") },
                            model: {
                              value: _vm.lines.Value.Translations[_vm.lang],
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.lines.Value.Translations,
                                  _vm.lang,
                                  $$v
                                )
                              },
                              expression: "lines.Value.Translations[lang]",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "w-col",
                        { attrs: { center: "" } },
                        [
                          _c(
                            "w-button",
                            {
                              directives: [
                                {
                                  name: "tooltip",
                                  rawName: "v-tooltip",
                                  value: _vm.$ct(`tooltip.style-edit`),
                                  expression: "$ct(`tooltip.style-edit`)",
                                },
                              ],
                              attrs: { icon: "" },
                              on: {
                                click: function ($event) {
                                  _vm.editStyle = true
                                },
                              },
                            },
                            [
                              _c("w-fa", {
                                attrs: { size: "lg", icon: "font" },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm.editStyle
        ? _c(
            "w-modal",
            { attrs: { value: _vm.editStyle } },
            [
              _c("app-style-editor", {
                on: {
                  close: function ($event) {
                    _vm.editStyle = false
                  },
                },
                model: {
                  value: _vm.lines.Style,
                  callback: function ($$v) {
                    _vm.$set(_vm.lines, "Style", $$v)
                  },
                  expression: "lines.Style",
                },
              }),
            ],
            1
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }